export enum PlatformName {
  IOS = 'ios',
  IPAD = 'ipad',
  IPHONE = 'iphone',
  IPOD = 'ipod',
  ANDROID = 'android',
  MAC = 'mac',
  WINDOWS = 'windows',
  LINUX = 'linux',
  CHROME = 'chrome',
  FIREFOX = 'firefox',
  SAFARI = 'safari',
  OPERA = 'opera',
  EDGE = 'edge',
  UNKNOWN = 'unknown',
}
